import React, {useContext, useEffect, useRef} from 'react';
import {AppContext} from '../contexts/context';

// Components
import ScanDialog from './ScanDialog'
import DataDisplay from '../components/DataDisplay'
import AppSnackbar from './AppSnackbar';
import {
  AttentionCard,
  WarningCard,
  AppInfoCard,
  AppInstallableCard,
  AppOpenCard,
  AppRepairDataCard,
  AppUpdateCard,
  NfcNotAvailableCard,
  NfcNotGrantedCard,
  UseIosCard
} from './AppCards';
import DataExchangeFab from './DataExchangeFab';

// Material UI
import {makeStyles} from '@mui/styles';
import {useCountDataKeys, useCountImportedValues} from "./AppUtils";

const useStyles = makeStyles((theme) => ({
  card: {
    margin: 10,
    paddingBottom: 0,
  },
  button: {
    marginRight: 10,
  },
  snackbar: {
    /* [theme.breakpoints.down('xs')]: {
      bottom: 90,
    }, */
  },
}));

function DataPage(props) {
  const classes = useStyles();
  const [ state, dispatch ] = useContext(AppContext);
  const importedParams = useCountImportedValues();
  const changedParams = useCountDataKeys();

  // Scan dialog mode switch
  const scanDialogModeSwitchRef = useRef(state.scanDialogModeSwitch);
  useEffect(() => {
    scanDialogModeSwitchRef.current = state.scanDialogModeSwitch;
  }, [state.scanDialogModeSwitch]);

  // console.debug("DataPage: Re-Render ...")

  const onDataExchangeActionFab = () => {
    // Open scan dialog
    dispatch({type: 'app/ui/dialog/ndef/show', value: true})
    dispatch({type: 'ndef/scan/scanning'});

    // Decide if data should be written or read to/from devide
    console.debug("ScanDialog | Check against new read with changed parameters");
    switch(state.nfcDataSource) {
      case 'unknown':
      case 'app':
      case 'scan':
        if(changedParams > 0 || state.nfcDataScanTime !== "unknown") {
          dispatch({type: 'app/ui/scanDialog/modeSwitch/available'});
          // Switch between read and write
          console.warn("ScanDialog | Switch between read and write");
          dispatch({type: 'ndef/control/idle'});
        } else {
          dispatch({type: 'ndef/control/reading'});
          dispatch({type: 'app/ui/scanDialog/modeSwitch/unavailable'});
        }
        break;
      case 'import':
        //Enable Write
        console.warn("ScanDialog | Enable Write");
        dispatch({type: 'ndef/control/writing'});
        dispatch({type: 'app/ui/scanDialog/writeInitializer', value: importedParams})
        dispatch({type: 'app/ui/scanDialog/modeSwitch/unavailable'});
        break;
      default:
        dispatch({type: 'ndef/control/reading'});
        dispatch({type: 'app/ui/scanDialog/modeSwitch/unavailable'});
        break;
    }
  }

  const handleAbortClick = () => {
    console.debug('handleAbortClick')
    // If scan dialog is idle or there is no mode switch, close scan dialog.
    if (state.ndefControl === "idle" || !scanDialogModeSwitchRef.current) {
      dispatch({type: 'app/ui/dialog/ndef/show', value: false})
    }
    // Always switch back to idle
    dispatch({type: 'ndef/control/idle'});
  }

  const handleComfirmationClick = () => {
    console.debug('handleComfirmationClick')
    dispatch({type: 'app/ui/dialog/ndef/show', value: false})
    dispatch({type: 'ndef/control/idle'});
  }

  const handlRetryClick = () => {
    console.debug('handlRetryClick')
    // dispatch({type: 'ndef/control/setForNewRead'});
    dispatch({type: 'app/ui/dialog/ndef/show', value: false})
    dispatch({type: 'app/ui/dialog/ndef/show', value: true})
    dispatch({type: 'ndef/control/reading'});
  }

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

  return (
    <>
      {Object.keys(state.nfcSchema).length <= 0 || state.nfcSchema.$id === "/schemas/Repair/v1.0.0"
        ? <div style={{marginInline:10, marginBlock:10, display:"flex", gap:10, flexDirection:"column"}}>
            <AppInfoCard/>
            {isSafari?'':<WarningCard/>}
            {state.uiCardNfcNotAvailable === 'show'
              ? (isSafari ? <UseIosCard/> : <NfcNotAvailableCard/>)
              : state.uiCardNfcNotGranted === 'show'
                ? <NfcNotGrantedCard/>
                : state.nfcSchema.$id === "/schemas/Repair/v1.0.0"
                  ? <AppRepairDataCard/>
                  : <AttentionCard Title={"Getting started"} Text={`Press the DATA EXCHANGE button to start the contactless reading of data.`} grantHandler={props.grantHandler}/>
            }
            {state.uiCardAppInstallable === 'show' && !isSafari
              ? <AppInstallableCard/>
                : state.uiCardAppOpen === 'show' && !isSafari
                  ? <AppOpenCard/>
                  : ''
            }
            {state.appSwUpdated === true
              ? <AppUpdateCard/>
              : <></>
            }
          </div>
        : ''
      }
      {(Object.keys(state.nfcSchema).length > 0 && state.ndefControl === 'idle' && state.nfcSchema.$id !== "/schemas/Repair/v1.0.0") && (
        <DataDisplay />
      )}

      {state.uiScanDialog?
        <ScanDialog
          abortHandler={handleAbortClick}
          retryHandler={handlRetryClick}
          confirmHandler={handleComfirmationClick}
        /> :
        <div></div>
      }

      {!isSafari?<DataExchangeFab onClick={onDataExchangeActionFab}/> :''}
      <AppSnackbar
        classes={classes.snackbar}
      />
    </>
  )
};

export default DataPage;
